import React, { useRef, useEffect, useState } from "react";
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";
import ClientePorFactura from "../../../components/autocomplete/FacturaClienteAutocomplete";
import EstadoSelect from "../../../components/select/EstadoSelect";

export default function FiltroFacturasGeneradas({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const adaptNombre = (e) => (e ? { ...e, label: e.nombre } : null);

  const filtroRef = useRef(null);

  // ============================
  //        ESTADOS (rehidratables)
  // ============================

  const [cliente, setCliente] = useState(
    adaptNombre(initialFilters.cliente) ?? null
  );

  const [liquidacion, setLiquidacion] = useState(
    initialFilters.liquidacion ?? null
  );


  const [numero, setNumero] = useState(initialFilters.numero ?? "");
  const [numeroNotacredito, setNumeroNotacredito] = useState(
    initialFilters.numeroNotacredito ?? ""
  );

    const [facturaCliente, setFacturaCliente] = useState(
        initialFilters.facturaCliente ?? null
    );

  const [estado, setEstado] = useState(
  initialFilters.estado ?? null
);

  // ============================
  //   CERRAR CLICK FUERA / ESC
  // ============================
  useEffect(() => {
    const outside = (event) => {
      if (filtroRef.current && !filtroRef.current.contains(event.target)) {
        onClose();
      }
    };

    const esc = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // ============================
  //        SUBMIT
  // ============================
  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit({
        cliente,
        facturaCliente,
        estado,
        
        numero,
        numeroNotacredito,
        

        // 🔥 ids backend
        clienteId: cliente?.id ?? null,
        facturaClienteId: facturaCliente?.id ?? null,
        estadoId: estado?.id ?? null,
    });
  };

  const clearNumber = (v) => {
    if (v === "" || v == null) return "";
    // deja solo dígitos
    return String(v).replace(/[^\d]/g, "");
  };


  // ============================
  //        RENDER
  // ============================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          
          {/* Cliente */}
          <div>
            <label className="form-label-fil">Cliente</label>
            <ClienteAutocomplete
              value={cliente}
              onChange={(e) => setCliente(adaptNombre(e))}
              placeholder="Buscar Cliente..."
            />
          </div>

          {/* facturaCliente */}
          <div>
            <label className="form-label-fil">Cliente Por Factura</label>
            <ClientePorFactura
                value={facturaCliente}
                onChange={setFacturaCliente}
            />
          </div>

          {/* Número */}
          <div>
            <label className="form-label-fil">Número</label>
            <input
              className="input"
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
              placeholder="Ej: F001-00001234"
            />
          </div>

          {/* Nota crédito */}
          <div>
            <label className="form-label-fil">Nota crédito</label>
            <input
              className="input"
              value={numeroNotacredito}
              onChange={(e) => setNumeroNotacredito(e.target.value)}
              placeholder="Ej: NC001-00000001"
            />
          </div>          

          {/* EstadoId */}
          <div>
            <label className="form-label-fil">Estado</label>
            <EstadoSelect
                value={estado}
                tipoId={9}
                onChange={setEstado}
            />
          </div>

          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
